import { render, staticRenderFns } from "./contract-new2.vue?vue&type=template&id=cf1bbcfa&scoped=true"
import script from "./contract-new2.vue?vue&type=script&lang=js"
export * from "./contract-new2.vue?vue&type=script&lang=js"
import style0 from "./contract-new2.vue?vue&type=style&index=0&id=cf1bbcfa&prod&lang=scss"
import style1 from "./contract-new2.vue?vue&type=style&index=1&id=cf1bbcfa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf1bbcfa",
  null
  
)

export default component.exports